import script from "./AudioContentReader.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioContentReader.vue?vue&type=script&setup=true&lang=js"

import "./AudioContentReader.vue?vue&type=style&index=0&id=b522e170&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b522e170"]])

export default __exports__